import { gql } from '@apollo/client';

/**
 * 「扫码换单查询」外部员工版本（HUB_OPERATOR / SORTING_STAFF 等一线角色调用）。
 * 与 CHECK_ORDER_FOR_RELABEL 字段结构一致，仅后端入口方法不同。
 * 使用 GraphQL 别名 `checkOrderForRelabel: checkOrderForRelabelForExternalStaff` 让响应字段名保持一致，
 * 下游可直接复用 CheckOrderForRelabelResponse 类型。
 */
export const CHECK_ORDER_FOR_RELABEL_FOR_EXTERNAL_STAFF = gql`
    query CheckOrderForRelabelForExternalStaff($neutralTrackingNumber: String!) {
        checkOrderForRelabel: checkOrderForRelabelForExternalStaff(neutralTrackingNumber: $neutralTrackingNumber) {
            orderId
            trackingNumber
            externalTrackingNumber
            isTemuUsps
            needsRelabel
            recipientName
            recipientAddressLine
            recipientCityLine
        }
    }
`;
